import React from 'react';
import { Card, Col, Row } from 'antd';
import LineChart from '../Chart/LineChart';
import PieChart from '../Chart/PieChart';
import BarChart from '../Chart/BarChart';

const SmartBuildingDashboard = () => {
  // 共用變數
  const data = [
    {
      title: '公設預約',
      tableName: 'publicAppointmentHour',
      chartType: 'lineChart',
      deviceTable: ['publicInformationHour', 'publicInformationCount'],
      deviceIndex: 'publicName',
      onDevice: true,
      onUnit: true,
    },
    {
      title: '郵件包裹',
      tableName: 'postalRegistration',
      chartType: 'pieChart',
      deviceTable: ['postalRegistration'],
      deviceIndex: 'packageType',
      onDevice: true,
      onUnit: false,
    },
    {
      title: '報修管理',
      tableName: 'fix',
      chartType: 'lineChart',
      deviceTable: ['fix'],
      deviceIndex: 'title',
      onDevice: true,
      onUnit: true,
    },
    {
      title: '報修管理',
      tableName: 'fix',
      chartType: 'pieChart',
      deviceTable: ['fix'],
      deviceIndex: 'title',
      onDevice: true,
      onUnit: false,
    },
    {
      title: 'BA設備管理錯誤率',
      tableName: 'baDeviceUsageRecord',
      chartType: 'pieChart',
      deviceTable: ['baDeviceUsageRecord'],
      deviceIndex: 'name',
      onDevice: true,
      onUnit: false,
    },
    {
      title: 'BA設備管理',
      tableName: 'baDeviceUsageRecord',
      chartType: 'barChart',
      deviceTable: ['baDeviceUsageRecord'],
      deviceIndex: 'name',
      onDevice: true,
      onUnit: false,
      excelUrl: '/ezcon/api/BAExcel',
      excelName: 'BA設備運轉記錄',
    },
    {
      title: '機電巡檢結果劣等率',
      tableName: 'machineInspectResult',
      chartType: 'pieChart',
      deviceTable: ['communityDevice'],
      deviceIndex: 'deviceName',
      onDevice: true,
      onUnit: false,
    },
    {
      title: '機電巡檢結果',
      tableName: 'machineInspectResult',
      chartType: 'barChart',
      deviceTable: ['communityDevice'],
      deviceIndex: 'deviceName',
      onDevice: true,
      onUnit: false,
      excelUrl: '/ezcon/api/machineInspectExcel',
      excelName: '機電巡檢結果',
    },
  ];

  return (
    <>
      <Row gutter={[16, 16]}>
        {data.map((item) => {
          return (
            <>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card title={item.title} bordered={false}>
                  {item.chartType === 'lineChart' && <LineChart {...item} />}
                  {item.chartType === 'pieChart' && <PieChart {...item} />}
                  {item.chartType === 'barChart' && <BarChart {...item} />}
                </Card>
              </Col>
            </>
          );
        })}
      </Row>
    </>
  );
};

export default SmartBuildingDashboard;
